import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import smallLogo from "../assets/smallLogo.png";
import "../styles.scss";


const MobileNavigationBar = () => {

  // State to control the slide-in menu visibility
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Toggle the menu
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <Navbar bg="light" expand="lg" className="shadow-sm">
      <Container>
        <Navbar.Brand href="/">
          <img src={smallLogo} alt="Logo" className="logo small" style={{ width: '50px', height: 'auto' }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleMenu} style={{ borderColor: '#F8F9FA', }} />

        <div className={`side-menu ${isMenuOpen ? "open" : ""}`}>
          <img src={smallLogo} alt="Logo" className="logo small" style={{ width: '40px', height: 'auto' }} />

          <span className="close-btn" onClick={toggleMenu}>×</span>
            {/* <div className="nav-link d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }}>
              <a href="/WhatWeDo" onClick={toggleMenu} style={{color: '#3C256B'}}className="flex-grow-1 text-decoration-none ">
                What We Do
              </a>
              <span onClick={() => setShowSubMenu(!showSubMenu)}>
                {showSubMenu ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>


            {showSubMenu && (
              <div className="ps-4">
                <Nav.Link href="/Eid-Al-Adha" onClick={toggleMenu}>Eid-Al-Adha</Nav.Link>
              </div>
            )} */}
          <Nav className="flex-column">
            <Nav.Link href="/" onClick={toggleMenu}>Home Page</Nav.Link>
            <Nav.Link href="/WhatWeDo" onClick={toggleMenu}>What We Do</Nav.Link>
            <Nav.Link href="/HowItWorks" onClick={toggleMenu}>How It Works</Nav.Link>
            <Nav.Link href="/NonMuslims" onClick={toggleMenu}>Non-Muslims</Nav.Link>
            <Nav.Link href="/Eid-Al-Adha" onClick={toggleMenu}>Eid-Al-Adha</Nav.Link>
            <Nav.Link href="/ApplyForHelp" target="_blank" onClick={toggleMenu}>APPLY FOR HELP</Nav.Link>
            <Nav.Link href="/PayZakatHere" onClick={toggleMenu}>Pay Zakat Here</Nav.Link>

            <div className="ps-2 mt-3" style={{ fontWeight: 700 }}>About Us</div>
            <Nav.Link href="/FAQ" onClick={toggleMenu}>FAQ</Nav.Link>
            <Nav.Link href="/Contact" onClick={toggleMenu}>Contact Us</Nav.Link>
            <Nav.Link href="/Testimonials" onClick={toggleMenu}>Testimonials</Nav.Link>
            <Nav.Link href="/Musallah" onClick={toggleMenu}>Musallah</Nav.Link>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};

export default MobileNavigationBar;
